module.exports = __webpack_public_path__ + "static/media/history_hoa_hong.6c86cbbc.png";